import { createContext, useContext } from 'react';

export const SessionQueryParamContext = createContext<readonly string[]>([]);

export function useSessionQueryParams(): readonly string[] {
  return useContext(SessionQueryParamContext);
}
